import {useRouter} from 'next/router'

export function useCurrentPath(): string {
  const router = useRouter()
  const hasSlash = router.asPath.slice(-1) === '/'
  const currentPath = `${router.asPath}${hasSlash ? '' : '/'}`
  return currentPath
}
